import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { CallDetailLogModel } from 'src/app/shared/models/calllog.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { CallLogService } from 'src/app/shared/services/calllog.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-calllog-recent',
  templateUrl: './calllog-recent.component.html',
  styleUrls: ['./calllog-recent.component.css']
})
export class CalllogRecentComponent implements OnInit {

  users : UserModel [];
  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['status', 'call', 'loginName'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
 
  constructor(
    private service :CallLogService, 
    private userservice : UserService ) { 

    }

  ngOnInit() {
    

    this.userservice.getUserList().subscribe(
      res=>{
        this.users = res as UserModel [];
        this.refreshList();
      },
      err=>{}
    );

    
  }
  
  
  refreshList()
  {
      this.service.getRecentCallList(5).subscribe(
        res => {
          let array = res as CallDetailLogModel[];
          let result = array.map(
            obj => {
              obj.createByUser = this.users.find(item => item.id === obj.createBy);
              return {...obj}
            }
          );
  
          this.thisData = new MatTableDataSource(array);
     //     this.thisData.sort = this.sort;
    //      this.thisData.paginator = this.paginator;
    
          console.log("refreshList : " + this.thisData.data.length);
         },
         err =>{
           console.log(err);
         }
      );
   
  }

}
